import React from 'react';

import { LoadableHeadlessProbePostOfficePlacement } from '@atlassian/conversation-assistant-utils/LoadableHeadlessProbePostOfficePlacement';

import { RemoteChatInputPlacement } from './remote-chat-input-placement';

const renderRemotePlacement = (): React.JSX.Element | null => (
	<RemoteChatInputPlacement placementId="rovo-chat-input-side-panel" />
);

const ufoCustomDataKeys = {
	result: 'chatInputPlacementHeadlessProbeResult',
	responseMessageCount: 'chatInputPlacementHeadlessProbeResponseMessageCount',
	nonDismissedMessageCount: 'chatInputPlacementHeadlessProbeNonDismissedMessageCount',
};

export const HeadlessProbeChatInputPlacement = (): React.JSX.Element | null => {
	return (
		<LoadableHeadlessProbePostOfficePlacement
			placementId="rovo-chat-input-side-panel"
			renderRemotePlacement={renderRemotePlacement}
			ufoCustomDataKeys={ufoCustomDataKeys}
		/>
	);
};
